import { HttpErrorResponse } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ReplaySubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ClienteOutput } from "src/app/@shared/models/cliente.model";
import { Branch } from "src/app/@shared/models/filial.model";
import { ClienteService } from "src/app/services/cliente/cliente.service";
import { FilialService } from "src/app/services/filial/filial.service";
import { ManutencaoAbrangenciaService } from "src/app/services/manutencao-abrangencia/manutencao-abrangencia.service";
import { ConsultaCTEReq } from "src/app/services/gestao-de-cte/gestao-de-cte.model";
import { ManutencaoCTEService } from "src/app/services/gestao-de-cte/gestao-de-cte.service";
import { GestaoDeCteComponent } from "../gestao-de-cte.component";
import { ManutencaoEnvioCteService } from "src/app/services/manutencao-envio-cte/manutencao-envio-cte.service";
import { Validacoes } from "src/app/@shared/helpers/validacoes";
import { MatDialog } from "@angular/material/dialog";
import { uploadTemplateOutput } from "../gestao-de-cte.model";
import { ProdutoOutput } from "src/app/@shared/models/produto.model";
import { ProdutoService } from "src/app/services/produto/produto.service";
import { ParametrosService } from "src/app/services/parametros/parametros.service";
import { ModalConfirmacaoComponent } from "src/app/@shared/components/modal-confirmacao/modal-confirmacao.component";

@Component({
  selector: "app-gestao-de-cte-filtro-pesquisa",
  templateUrl: "./gestao-de-cte-filtro-pesquisa.component.html",
  styleUrls: ["./gestao-de-cte-filtro-pesquisa.component.scss"],
})
export class GestaoDeCTEFiltroPesquisaComponent
  implements OnInit {
  @Input() parent: GestaoDeCteComponent;
  @Input() formPesquisa;

  arquivoFiltro: uploadTemplateOutput;

  clientes: ClienteOutput[];
  produtos: ProdutoOutput[];
  classes: any[];
  filiais: any[];
  receitas: any[];
  categorias: any[];

  get isLoading() {
    return this.parent.isLoading;
  }

  set isLoading(value) {
    this.parent.isLoading = value;
  }

  private onDestroy = new Subject<void>();
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<ClienteOutput[]>(1);
  public clienteMultiFilter: FormControl = new FormControl();
  
  public filteredProdutos: ReplaySubject<ProdutoOutput[]> = new ReplaySubject<ProdutoOutput[]>(1);
  public produtoMultiFilter: FormControl = new FormControl();

  public filteredClasses: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public classeMultiFilter: FormControl = new FormControl();

  public filteredFiliais: ReplaySubject<Branch[]> = new ReplaySubject<Branch[]>(1);
  public filialMultiFilter: FormControl = new FormControl();

  public filteredReceitas: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public receitaMultiFilter: FormControl = new FormControl();

  public filteredCategorias: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public categoriaMultiFilter: FormControl = new FormControl();

  listaTipoProcessamento: any;
  listaStatusCTE: any;
  listaStatusCancelamento: any;
  listaTipoCTE: any;
  listaFilialEmissao: any;
  fileInput: any;

  exibeCaixaUpload: boolean = false;
  exibeCaixaFiltrosCompleto: boolean = false;

  esconderBtAvancar: boolean = true;
  labelBtAvancar: string = "Avançar";

  actionMenu = [];
  actionMenuGeral = [];
  tipoFiltroOpts = [
    { id: 1, descricao: "Filtro por Upload" },
    { id: 2, descricao: "Filtros Gerais" }
  ];

  formAction = new FormGroup({
    menuAcoes: new FormControl('')
  });

  filename: string = '';
  file;

  tipoFiltro;

  // get idAcao() { return this.parent.idAcao; }
  // set idAcao(value) { this.parent.idAcao = value; }

  get dtEmissaoIni() { return this.formPesquisa.get('dtEmissaoIni').value; }
  get dtEmissaoFim() { return this.formPesquisa.get('dtEmissaoFim').value; }
  get nrtCodVolDoc() { return this.formPesquisa.get('nrtCodVolDoc').value; }
  get clienteId() { return this.formPesquisa.get('clienteId').value; }
  get produtoId() { return this.formPesquisa.get('produtoId').value; }
  get tipoCteId() { return this.formPesquisa.get('tipoCteId').value; }
  get tipoProcessamentoId() { return this.formPesquisa.get('tipoProcessamentoId').value; }
  get statusId() { return this.formPesquisa.get('statusId').value; }
  get chaveCTE() { return this.formPesquisa.get('chaveCTE').value; }
  get numCTE() { return this.formPesquisa.get('numCTE').value; }
  get filialEmissaoCodigo() { return this.formPesquisa.get('filialEmissaoCodigo').value; }
  get tipoStatusCancelamentoId() { return this.formPesquisa.get('tipoStatusCancelamentoId').value; }

  maxPeriodDataFiltro: number = 15;

  constructor(
    public service: ManutencaoCTEService,
    public manutencaoAbrangenciaService: ManutencaoAbrangenciaService,
    public manutencaoEnvioCte: ManutencaoEnvioCteService,
    public filialService: FilialService,
    public clienteService: ClienteService,
    public produtoService: ProdutoService,
    public dialog: MatDialog,
    private parametrosService: ParametrosService
  ) { }

  ngOnInit() {
    this.carregarDados();
    this.parametrosService.parametros("VESTA_GESTAOCTE_MAXPERIODODATA").subscribe(response => {
      this.maxPeriodDataFiltro = response?.valor ?? 15; // limite de códigos setados via parametro
    });
  }

  public clearFieldsDoc() {
    this.parent.exibirGrid = false;
    this.arquivoFiltro = null;
    this.file = null;
    this.filename = '';
    this.fileInput = null;
  }

  public clearFieldsDocFilter() {
    this.parent.exibirGrid = false;
    this.formPesquisa.get('filialEmissaoCodigo').setValue("");
    this.formPesquisa.get('tipoCteId').setValue("");
    this.formPesquisa.get('tipoProcessamentoId').setValue("");
    this.formPesquisa.get('statusId').setValue("");
    this.formPesquisa.get('tipoStatusCancelamentoId').setValue("");
    this.formPesquisa.get('clienteId').setValue("");
    this.formPesquisa.get('produtoId').setValue("");
  }

  public carregarDatas() {
    let hoje = new Date();
    let hojeMenos15 = new Date();
    let intervalo = this.maxPeriodDataFiltro; //
    hojeMenos15.setDate(hoje.getDate() - intervalo);
    this.setValue("dtEmissaoIni", hojeMenos15);
    this.setValue("dtEmissaoFim", hoje);
  }


  public carregarDados() {
    this.carregarDatas();
    this.isLoading = true;
    Promise.all([
      this.consultaTipoCTE(),
      this.consultaTipoAcaoCTE(),
      this.consultaStatusCTE(),
      this.consultaStatusCancelamento(),
      this.consultaListaTipoProcessamento(),
      this.consultaFilialEmissao(),
      this.listarClientes(),
      this.listarClasses(),
      this.listarFiliais(),
      this.checarPreLoteAtivo(this.parent.acaoGeral.id)
    ]).then(() => this.isLoading = false);
  }

  public async listarClientes() {
    return this.clienteService
      .list()
      .toPromise()
      .then(
        (response: ClienteOutput[]) => {
          this.clientes = response
            .filter((x) => x.nome != "")
            .sort((a, b) => (a.nome < b.nome ? -1 : 1));
          this.filteredClientes.next(this.clientes.slice());
          this.clienteMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.clientes,
                this.clienteMultiFilter,
                this.filteredClientes,
                "nome"
              );
            });
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.parent.openSnackBar(
            "Erro ao carregar clientes, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async listarProdutos() {
    this.formPesquisa.get('produtoId').setValue("");
    this.produtos = [];
    return this.produtoService.selecionarProdutos(this.clienteId).toPromise().then((response: ProdutoOutput[]) => {
      this.produtos = response.filter(x => x.descricao != '').sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
      this.filteredProdutos.next(this.produtos.slice());
      this.produtoMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.produtos, this.produtoMultiFilter, this.filteredProdutos, 'descricao');
        });
      if (!this.produtos.length) {
        this.parent.openSnackBar('Este cliente não possui produtos cadastrados!', 'OK', 5000, 'warning-snackbar');
        this.formPesquisa.get('produtoSelecionado').disable();
      }
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.parent.openSnackBar('Erro ao carregar produtos, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  public async listarClasses() {
    return this.manutencaoAbrangenciaService
      .selecionarClasses()
      .toPromise()
      .then(
        (response: any[]) => {
          this.classes = response
            .filter((x) => x.descricao != "")
            .sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
          this.filteredClasses.next(this.classes.slice());
          this.classeMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.classes,
                this.classeMultiFilter,
                this.filteredClasses,
                "descricao"
              );
            });
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.parent.openSnackBar(
            "Erro ao carregar classes, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async listarFiliais() {
    return this.filialService
      .listarFilialDestino()
      .toPromise()
      .then(
        (response: any) => {
          this.filiais = response
            .filter((x) => x.descricao)
            .sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
          this.filteredFiliais.next(this.filiais.slice());
          this.filialMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.filiais,
                this.filialMultiFilter,
                this.filteredFiliais,
                "descricao"
              );
            });
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.parent.openSnackBar(
            "Erro ao carregar filiais, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async consultaTipoCTE() {
    return this.manutencaoEnvioCte
      .consultaListaTipoCTE()
      .toPromise()
      .then(
        (response: any) => {
          this.listaTipoCTE = response;//.filter((el) => el.id != 5);
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.parent.openSnackBar(
            "Erro ao carregar consulta de Tipo CTE, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }
  public handleacaoGeral(event) {
    this.parent.exibirGrid = false;

    let optGeral = this.parent.acaoGeral;
    let optTipo = this.tipoFiltro;

    this.exibeCaixaUpload = false;
    this.exibeCaixaFiltrosCompleto = false;

    this.checarPreLoteAtivo(optGeral.id);

    switch (optTipo.id) {
      case 1:
        this.exibeCaixaUpload = true;
        break;
      case 2:
        this.exibeCaixaFiltrosCompleto = true;
        break;
    }
  }

  public async consultaTipoAcaoCTE() {
    return this.service
      .consultaAcoesCTE()
      .toPromise()
      .then(
        (response: any) => {
          this.actionMenu = response;
          this.actionMenuGeral = response;
          this.parent.acaoGeral.descricao = response.filter(r => r.id == this.parent.acaoGeral.id)[0].descricao;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.parent.openSnackBar(
            "Erro ao carregar consulta de Tipo de Ações CTE, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async consultaListaTipoProcessamento() {
    return this.manutencaoEnvioCte
      .consultaListaTipoProcessamento()
      .toPromise()
      .then(
        (response: any) => {
          this.listaTipoProcessamento = response;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.parent.openSnackBar(
            "Erro ao carregar consulta de Tipo Processamento, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async consultaStatusCTE() {
    return this.service
      .consultaStatusCTE()
      .toPromise()
      .then(
        (response: any) => {
          this.listaStatusCTE = response;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.parent.openSnackBar(
            "Erro ao carregar consulta de STATUS de CTE, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async consultaStatusCancelamento() {
    return this.service
      .consultaStatusCancelamento()
      .toPromise()
      .then(
        (response: any) => {
          this.listaStatusCancelamento = response;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.parent.openSnackBar(
            "Erro ao carregar consulta de STATUS de CTE, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async consultaFilialEmissao() {
    return this.service
      .consultaFilialEmissao()
      .toPromise()
      .then(
        (response: any) => {
          this.listaFilialEmissao = response;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.parent.openSnackBar(
            "Erro ao carregar consulta Filial de Emissão, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  private filtroGeral(
    filtro: any,
    multifilter: any,
    filtered: any,
    field: string
  ) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(
        (response) => response[field].toLowerCase().indexOf(search) > -1
      )
    );
  }

  getValue(fieldName) {
    return this.formPesquisa?.get(fieldName)?.value;
  }

  public setValue(propName, value) {
    return this.formPesquisa.get(propName)?.setValue(value);
  }

  minChars = 1;
  validar() {
    const charFields = [
      {
        input: "dataInicio",
        type: "date",
        interval: "start",
      },
      {
        input: "dataFim",
        type: "date",
        interval: "end",
      },
    ];

    var validateChars = (field) =>
      field.type == "date" ?
        Validacoes.dateDiff(this.getValue("dtEmissaoIni"), this.getValue("dtEmissaoFim"))["d"] >= 0 && Validacoes.dateDiff(this.getValue("dtEmissaoIni"), this.getValue("dtEmissaoFim"))["d"] <= this.maxPeriodDataFiltro
        : this.getValue(field.input)?.toString().length >= this.minChars;
    return charFields.some(validateChars);
  }

  fixPagination() {
    /* ao selecionar algum filtro, zerar a paginação*/
    this.parent.setPage("0");
  }

  trigger() {

    if (this.validar()) {

      var filters = {
        dtEmissaoIni: this.dtEmissaoIni ? this.dtEmissaoIni.toISOString().split('T')[0] : null,
        dtEmissaoFim: this.dtEmissaoFim ? this.dtEmissaoFim.toISOString().split('T')[0] : null,
        nrtCodVolDoc: this.nrtCodVolDoc,
        clienteId: this.clienteId,
        produtoId: this.produtoId,
        tipoCteId: this.tipoCteId,
        tipoProcessamentoId: this.tipoProcessamentoId,
        statusId: this.statusId,
        chaveCTE: this.chaveCTE,
        numCTE: this.numCTE,
        filialEmissaoCodigo: this.filialEmissaoCodigo,
        tipoStatusCancelamentoId: this.tipoStatusCancelamentoId,
        reemissao: null
      } as ConsultaCTEReq;

      this.parent.carregarGrid(filters, (response) => {
        this.parent.exibirGrid = response.length > 0;
      });
    }
  }

  public changeAction($event: any) {
    this.checarPreLoteAtivo(this.parent.acaoGeral.id);
    //this.preparaBotaoAvancar($event.value);
  }

  // public changeActionGeral($event: any) {
  //   this.parent.acaoGeral =
  //   this.checarPreLoteAtivo(this.parent.acaoGeral.id);
  //   //this.preparaBotaoAvancar($event.value);
  // }

  // public preparaBotaoAvancar(id) {
  //   this.esconderBtAvancar = false;
  //   switch (id) {
  //     case 1:
  //       this.esconderBtAvancar = false;
  //       this.labelBtAvancar = ""
  //       this.idAcao = id;
  //       break;
  //     case 2:
  //       this.esconderBtAvancar = false;
  //       this.labelBtAvancar = "Avançar em Anulação"
  //       this.idAcao = id;
  //       break;
  //     case 3:
  //       this.esconderBtAvancar = false;
  //       this.labelBtAvancar = "Avançar em Substituição"
  //       this.idAcao = id;
  //       break;
  //     case 4:
  //       this.esconderBtAvancar = false;
  //       this.labelBtAvancar = "Avançar em Complementar"
  //       this.idAcao = id;
  //       break;
  //     case 5:
  //       this.esconderBtAvancar = false;
  //       this.labelBtAvancar = "Avançar em Cancelamento"
  //       this.idAcao = id;
  //       break;
  //     case 6:
  //       this.esconderBtAvancar = false;
  //       this.labelBtAvancar = "Avançar em Carta Correção"
  //       this.idAcao = id;
  //       break;
  //   }
  // }


  loadFile(file) {
    if (file.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      && file.target.files[0].type !== 'application/vnd.ms-excel'
    ) {
      this.filename = '';
      this.file = null;
      return this.parent.openSnackBar(
        'Apenas arquivos .xls ou .xlsx são permitidos!',
        'OK',
        3000,
        'danger-snackbar'
      );
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file.target.files[0]);
      reader.onloadend = () => {
        this.file = reader.result;
      }
      this.filename = file.target.files[0].name;
      this.parent.nomeArquivo = this.filename;
      // const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      //   width: '540px',
      //   data: {
      //     titulo: "Upload de Lote",
      //     texto: `Deseja carregar os dados do arquivo ${file.target.files[0].name}?`
      //   },
      // });
      // dialogRef.afterClosed().subscribe(
      //   async response => {
      //     if (response === 1) {
      //       this.filename = file.target.files[0].name;

      //       this.uploadLote();
      //     } else {
      //       this.filename = '';
      //       this.file = '';
      //     }
      // });
    }
  }

  public gerarViaFiltro() {
    this.isLoading = true;
    this.service.gerarPreLoteViaFiltros(this.parent.acaoGeral.id, this.parent.filters)
      .subscribe(
        (response: any) => {
          if (response.body.teveSucesso) {
            //recebe identificador apos o upload, ex: identificador: "27b91b67-c80d-4dfd-a496-27f8df7b18b8"
            var prelote_filtros = response.body.data;
            this.parent.iniciarPreLoteAcao(prelote_filtros.identificador);
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.parent.openSnackBar(
            err.error.message,
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      );
  }

  public uploadLote() {
    if (this.filename && this.file && this.parent.acaoGeral) {
      this.carregarTemplate(this.parent.acaoGeral, this.file, this.filename);
    }
  }

  public downloadTemplate() {
    this.isLoading = true;

    this.service
      .exportarTemplate(this.parent.acaoGeral.id)
      .subscribe(
        (response: any) => {
          this.gerarArquivo2(
            response.retorno.fileContents,
            response.retorno.fileDownloadName,
            response.retorno.contentType
          );
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.parent.openSnackBar(
            `Erro ao exportar template modelo`,
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      )
      .add(() => (this.isLoading = false));
  }

  public async carregarTemplate(tipo, file, filename) {
    if (file) {
      await this.enviarArquivo(tipo, file, filename);
    }
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo2(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data);
    const blob = new Blob([arrBuffer], {
      type,
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public checarPreLoteAtivo(acao) {
    this.isLoading = true;
    this.service
      .checarPreLoteAtivo(acao)
      .subscribe(
        (response: any) => {
          this.isLoading = false;
          if (response?.identificador) {
            var registro = response;
            const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
              width: "540px",
              data: {
                titulo: "Resgatar dados",
                texto: `Encontramos um pré-lote náo finalizado contendo ${response.qtdeRegistros} CT-es. Clique em OK para continuar de onde parou, e em cancelar para eliminar os dados e iniciar um novo processamento.`,
              },
            });

            dialogRef.afterClosed().subscribe(async (response) => {
              if (response === 1) {
                // this.ocultarheader = false;
                // this.ocultarPaginacao = false;
                this.arquivoFiltro = registro;
                if (acao == 1)//somente consulta
                {
                  this.tipoFiltro = this.tipoFiltroOpts[0];
                  //carregar
                  this.parent.filtrarGridPrincipalViaUpload(registro);
                } else {
                  this.parent.openSnackBar("Você será redirecionado para continuar sua ação de " + this.parent.acaoGeral.descricao,
                    "OK",
                    3000,
                    "success-snackbar");
                  this.parent.iniciarPreLoteAcao(registro.identificador);
                }
              } else if (response == 0) {
                this.parent.deletarArquivoCarregado(registro.identificador);
              }
            });
          }
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.error(err);
        }
      );
  }

  public enviarArquivo(tipo, file, filename) {
    this.isLoading = true;
    if (file && tipo) {
      let arquivoHash = file.split(",")[1];
      let obj = {
        templateBase64: arquivoHash,
        nomeArquivo: filename
      };

      //limpar campo
      this.fileInput = null;

      this.service
        .gerarPreLoteViaUpload(tipo.id, obj)
        .subscribe(
          (response: any) => {
            if (response.body.teveSucesso) {
              //recebe identificador apos o upload, ex: identificador: "27b91b67-c80d-4dfd-a496-27f8df7b18b8"
              var prelote_arquivo = response.body.data;

              this.parent.openSnackBar(
                `Arquivo enviado com sucesso`,
                "OK",
                3000,
                "success-snackbar"
              );

              if (tipo.id == 1)//somente consulta
              {
                //carregar
                this.parent.filtrarGridPrincipalViaUpload(prelote_arquivo);
              } else {
                this.parent.iniciarPreLoteAcao(prelote_arquivo.identificador);
              }
            } else {
              this.parent.openSnackBar(
                response.body.mensagem,
                "OK",
                5000,
                "danger-snackbar"
              );
              this.isLoading = false;
            }
          },
          (err: HttpErrorResponse) => {
            this.isLoading = false;
            console.error(err);
            this.parent.openSnackBar(
              err.error.message,
              "OK",
              5000,
              "danger-snackbar"
            );
          }
        );
    }
  }
}
